<script>
import Games from "@/services/Games";

export default {
  data() {
    return {
      showModal: false,
      loading: false,
      error: null,
      stats: {
        totals: {
          attempts: 0,
          success: 0,
          failure: 0,
        },
        customers: [],
      },
      wordUsage: null,
      duplicates: [],
      wordInfo: {},
      gameId: "word_game",
    };
  },
  methods: {
    open(wordInfo = {}, gameId = "word_game") {
      this.wordInfo = wordInfo || {};
      this.gameId = gameId || "word_game";
      this.showModal = true;
      this.fetchStats();
    },
    close() {
      this.showModal = false;
    },
    reset() {
      this.loading = false;
      this.error = null;
      this.stats = {
        totals: {
          attempts: 0,
          success: 0,
          failure: 0,
        },
        customers: [],
      };
      this.wordUsage = null;
      this.duplicates = [];
      this.wordInfo = {};
    },
    async fetchStats() {
      const key =
        this.wordInfo.key || this.wordInfo.date || this.wordInfo.word || null;

      if (!this.gameId || !key) {
        this.error = "Missing game identifier or key for the selected word.";
        return;
      }

      this.loading = true;
      this.error = null;

      try {
        const response = await Games.getWordStats({
          game_id: this.gameId,
          key,
          word: this.wordInfo.word ?? null,
          language: this.wordInfo.language ?? null,
        });
        this.stats = response.data.data || this.stats;
        this.wordUsage =
          response.data.data?.word_usage !== undefined
            ? response.data.data.word_usage
            : null;
        this.duplicates = Array.isArray(response.data.data?.duplicates)
          ? response.data.data.duplicates
          : [];
      } catch (error) {
        this.error =
          error.response?.data?.error ||
          error.response?.data?.message ||
          error.message ||
          "Unable to load statistics.";
      } finally {
        this.loading = false;
      }
    },
    openDuplicate(entry) {
      if (!entry || !entry.date) {
        return;
      }

      this.wordInfo = {
        ...this.wordInfo,
        key: entry.date,
        date: entry.date,
      };

      this.fetchStats();
    },
  },
};
</script>

<template>
  <b-modal
    id="word_stats_modal"
    v-model="showModal"
    @hidden="reset"
    title="Word Game Statistics"
    title-class="font-18"
    size="lg"
  >
    <div v-if="wordInfo.word" class="mb-3">
      <h5 class="mb-1">{{ wordInfo.word }}</h5>
      <small class="text-muted">
        Language: {{ wordInfo.language || "n/a" }}
        <span v-if="wordInfo.date || wordInfo.key">
          • Key: {{ wordInfo.date || wordInfo.key }}
        </span>
      </small>
    </div>

    <div v-if="error" class="alert alert-danger">
      {{ error }}
    </div>

    <div v-else-if="loading" class="text-center py-4">
      <b-spinner class="align-middle text-primary"></b-spinner>
      <p class="mt-3 mb-0 text-muted">Loading statistics...</p>
    </div>

    <div v-else>
      <div class="row text-center mb-3">
        <div class="col-md-4 mb-2">
          <div class="card bg-light">
            <div class="card-body py-3">
              <h6 class="text-muted mb-1">Attempts</h6>
              <h4 class="mb-0">{{ stats.totals.attempts }}</h4>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-2">
          <div class="card bg-light">
            <div class="card-body py-3">
              <h6 class="text-success mb-1">Successful</h6>
              <h4 class="mb-0 text-success">{{ stats.totals.success }}</h4>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-2">
          <div class="card bg-light">
            <div class="card-body py-3">
              <h6 class="text-danger mb-1">Failed</h6>
              <h4 class="mb-0 text-danger">{{ stats.totals.failure }}</h4>
            </div>
          </div>
        </div>
<!--        <div class="col-md-4 mb-2" v-if="wordUsage !== null">-->
<!--          <div class="card bg-light">-->
<!--            <div class="card-body py-3">-->
<!--              <h6 class="text-primary mb-1">Occurrences in Dictionary</h6>-->
<!--              <h4 class="mb-0 text-primary">{{ wordUsage }}</h4>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>

      <div v-if="duplicates.length > 1" class="mt-4">
        <h6 class="mb-2">Word of the day on:</h6>
        <div class="table-responsive">
          <table class="table table-sm table-striped mb-0">
            <thead>
              <tr>
                <th scope="col">Language</th>
                <th scope="col">Word</th>
                <th scope="col">Date</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(duplicate, index) in duplicates"
                :key="`${duplicate.language}-${duplicate.date}-${index}`"
              >
                <td>{{ duplicate.language || "n/a" }}</td>
                <td>{{ duplicate.word }}</td>
                <td>
                  <a
                    v-if="duplicate.date"
                    href="javascript:void(0);"
                    @click="openDuplicate(duplicate)"
                  >
                    {{ duplicate.date }}
                  </a>
                  <span v-else>n/a</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else class="alert alert-info mb-0 mt-4">
        No duplicate dictionary entries found for this word.
      </div>
    </div>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="close">Close</b-button>
    </template>
  </b-modal>
</template>

